
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.607 30.312l16.288-16.218a.988.988 0 000-1.403.999.999 0 00-1.41 0L30.198 28.909 13.91 12.69a.999.999 0 00-1.41 0 .988.988 0 000 1.403l16.288 16.218L12.5 46.53a.988.988 0 00.71 1.693c.26 0 .51-.1.71-.29l16.288-16.217 16.287 16.218c.2.199.45.289.71.289.26 0 .51-.1.71-.29a.988.988 0 000-1.403L31.607 30.312z"}})])
          )
        }
      }
    